import { useCallback, useEffect, useState } from "react";

import { testsService } from "@/services/tests";
import { LightweightAllAvailableTreatments } from "@/types/care";

export const useLightweightAllAvailableTreatments = () => {
  const [data, setData] = useState<LightweightAllAvailableTreatments>();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);

  const fetchAllAvailableTreatments = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await testsService.fetchUserAllAvailableTreatments();
      setData(response.data);
    } catch (error: any) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllAvailableTreatments();
  }, [fetchAllAvailableTreatments, refetch]);

  const refetchAllAvailableTreatments = () => {
    setRefetch((prev) => !prev);
  };

  return {
    lightweightAllAvailableTreatments: data,
    error,
    isLoading,
    refetchAllAvailableTreatments,
  };
};
